import { Component, OnDestroy, OnInit, effect, inject } from '@angular/core';

import { Observable } from 'rxjs';

import { EnvironmentConfig, IConfiguration } from '../../../client-config';
import { CmsService } from '../../../core/services/cms/cms.service';
import { INavigationPoint } from '../../../core/services/cms/models';
import { PubSubService } from '../../../core/services/communication/pubsub/pubsub.service';
import { IFeaturedModule } from '../../../featured/components/featured-tab/featured-module.model';
import { AbstractOutletComponent } from '../../../shared/components/abstractOutlet/abstract-outlet.component';
import { LAZY_LOAD_ROUTE_PATHS } from '../../constants/lazyload-route-paths.constant';

@Component({
    selector: 'home',
    templateUrl: 'home.component.html',
    standalone: false,
})
export class HomeComponent extends AbstractOutletComponent implements OnInit, OnDestroy {
    femData: any;
    ribbon: IFeaturedModule[];
    isEnhancedMultiplesEnabled: boolean = false;
    bannerHome: string;
    private readonly title = 'HomeModuleComponent';
    private readonly environment: IConfiguration = inject(EnvironmentConfig).configuration;
    brand: string = this.environment.BRAND || '';
    isEntryBtnAvailable: boolean = false;
    isEntryBtnValidated: boolean = false;
    private hasNavPointForHome: any;
    showBanners: boolean;

    constructor(
        private cms: CmsService,
        protected pubSubService: PubSubService,
    ) {
        super() /* istanbul ignore next */;
        effect(() => {
            this.showBanners = this.cms.isDynamicBannersEnabled();
        });
    }

    override ngOnInit(): void {
        this.bannerHome = LAZY_LOAD_ROUTE_PATHS.home;
        this.moduleRibbonData();
        this.getHomeTabNavigationPoints();
        this.pubSubService.subscribe(this.title, [this.pubSubService.API.SEGMENTED_INIT_FE_REFRESH], () => {
            this.moduleRibbonData();
        });
    }

    moduleRibbonData() {
        this.cms.getRibbonModule().subscribe(
            (initialData: { getRibbonModule: IFeaturedModule[]; getMMOutcomesByEventType: any }) => {
                // to avoid this the bottle neck and having 500 error b/c of e.g.
                // banners have not been loaded.
                this.femData = initialData.getMMOutcomesByEventType;
                this.ribbon = initialData.getRibbonModule;

                this.hideSpinner();
            },
            () => {
                this.showError();
            },
        );
        this.getIsEnhancedMultiplesEnabled().subscribe((isEnhancedMultiplesEnabled: boolean) => {
            this.isEnhancedMultiplesEnabled = isEnhancedMultiplesEnabled;
        });
    }

    private getIsEnhancedMultiplesEnabled(): Observable<boolean> {
        return this.cms.getToggleStatus('EnhancedMultiples');
    }

    private getHomeTabNavigationPoints() {
        try {
            this.cms.getNavigationPoints(['/home/featured'], 'homeTabs').subscribe(
                (data: INavigationPoint[]) => {
                    this.hasNavPointForHome = data.filter((item: INavigationPoint) => {
                        return item.homeTabs.some((tab: string) => tab === '/home/featured');
                    });
                    this.isEntryBtnValidated = true;
                    const [entryPointData] = this.hasNavPointForHome;
                    this.isEntryBtnAvailable =
                        window.location.pathname === '/' &&
                        entryPointData &&
                        typeof entryPointData === 'object' &&
                        Object.keys(entryPointData).length > 0;
                },
                (error) => {
                    this.isEntryBtnValidated = true;
                    this.isEntryBtnAvailable = false;
                },
            );
        } catch (error) {
            this.isEntryBtnValidated = true;
            this.isEntryBtnAvailable = false;
        }
    }

    override ngOnDestroy() {
        super.ngOnDestroy();
        this.pubSubService.unsubscribe(this.title);
    }
}
